//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    requestBody: {
        collection: string,
        game_details: {
            demo: boolean,
            description: string,
            image: string,
            image_square: string,
            image_vertical: string,
            jackpot_amount: string,
            launch_game_id: string,
            max_bet: string,
            max_win: string,
            min_bet: string,
            name: string,
            provider: string,
            published: boolean,
            return_to_player: string,
            studio_id: string,
            studio_name: string,
        },
    },
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/casino/management/game/add-new -> post -> ${code}`);
    };
};

const Response200IO = t.interface({
    new_game: t.interface({
        demo: t.boolean,
        description: t.string,
        id: t.number,
        image: t.string,
        image_square: t.string,
        image_vertical: t.string,
        jackpot_amount: t.string,
        launch_game_id: t.string,
        max_bet: t.string,
        max_win: t.string,
        min_bet: t.string,
        name: t.string,
        provider: t.string,
        published: t.boolean,
        return_to_player: t.string,
        studio_id: t.string,
        studio_name: t.string,
        universe: t.string,
    }),
});
export type Response200Type = {
    new_game: {
        demo: boolean,
        description: string,
        id: number,
        image: string,
        image_square: string,
        image_vertical: string,
        jackpot_amount: string,
        launch_game_id: string,
        max_bet: string,
        max_win: string,
        min_bet: string,
        name: string,
        provider: string,
        published: boolean,
        return_to_player: string,
        studio_id: string,
        studio_name: string,
        universe: string,
    },
};
export const decodeResponse200 = createGuard(200, Response200IO);

const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiCategoriesAndGamesStaffAddNewGameRequest"
 */
export const openapi_categories_and_games_staff_add_new_game = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/casino/management/game/add-new${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiCategoriesAndGamesStaffAddNewGameParamsType = ParamsType;

export type OpenapiCategoriesAndGamesStaffAddNewGameResponseType = {
    status: 200,
    body: Response200Type,
} | {
    status: 400,
    body: Response400Type,
} | {
    status: 401,
    body: Response401Type,
} | {
    status: 500,
    body: Response500Type,
};

export type OpenapiCategoriesAndGamesStaffAddNewGameResponse200Type = Response200Type;

export const openapiCategoriesAndGamesStaffAddNewGameRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiCategoriesAndGamesStaffAddNewGameResponseType> => {
    const response = await openapi_categories_and_games_staff_add_new_game(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        throw Error(`Http status ${status} - json was expected`);
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiCategoriesAndGamesStaffAddNewGameRequest - unhandled response ${response.status}`);
};

